import { CopyIconButton } from '@components/button';
import { Checkbox } from '@components/form';
import { DateAndUserDisplay, Typography } from '@components/typography';
import { Dataset } from '@generated/graphql';
import { TableCell } from '@mui/material';
import { useDatasets } from '@subsets/workspaces';
import { memo } from 'react';
import { DatasetStatusIcon } from './DatasetStatusIcon';

type DatasetTableRowProps = {
  organizationId: string;
  workspaceId: string;
  dataset: Pick<
    Dataset,
    'datasetId' | 'name' | 'channel' | 'runs' | 'createdAt' | 'createdBy' | 'type' | 'status'
  >;
};

export const DatasetsTableRow = memo(
  ({
    workspaceId,
    organizationId,
    dataset: { datasetId, name, channel, runs, createdBy, createdAt, status, type },
  }: DatasetTableRowProps) => {
    const { selectedDatasets, setSelectedDatasets } = useDatasets();
    const selected = selectedDatasets.includes(datasetId);
    const handleSelect = () => {
      if (selected) {
        setSelectedDatasets(selectedDatasets.filter((id) => id !== datasetId));
      } else {
        setSelectedDatasets([...selectedDatasets, datasetId]);
      }
    };
    return (
      <>
        <TableCell width="30px">
          <Checkbox
            checked={selected}
            onClick={(event) => {
              event.preventDefault();
              event.stopPropagation();
              handleSelect();
            }}
          />
        </TableCell>
        <TableCell width="30px">
          <CopyIconButton value={datasetId} showValue />
        </TableCell>
        <TableCell width="250px">
          <Typography handleOverFlow variant="body2">
            {name}
          </Typography>
        </TableCell>
        <TableCell width="250px">
          <Typography handleOverFlow variant="body2">
            {type === 'synthetic'
              ? channel
              : type === 'upload'
                ? 'Upload'
                : type === 'mixed'
                  ? 'Mixed'
                  : type === 'gan'
                    ? 'GAN'
                    : 'Unknown'}
          </Typography>
        </TableCell>
        <TableCell width="30px">
          <Typography handleOverFlow variant="body2">
            {runs}
          </Typography>
        </TableCell>
        <TableCell width="345px">
          <DateAndUserDisplay date={createdAt} user={createdBy} />
        </TableCell>
        <TableCell width="30px">
          <DatasetStatusIcon
            status={status}
            organizationId={organizationId}
            workspaceId={workspaceId}
            datasetId={datasetId}
          />
        </TableCell>
      </>
    );
  },
);
